export const saveFilters = (key, filters, userId) => {
    localStorage.setItem(`${userId}_${key}`, JSON.stringify(filters));
};

export const loadFilters = (key, defaultFilters, userId) => {
    try {
        const saved = localStorage.getItem(`${userId}_${key}`);
        return saved ? { ...defaultFilters, ...JSON.parse(saved) } : defaultFilters;
    } catch {
        return defaultFilters;
    }
};

export const clearSavedFilters = (key, userId) => {
    localStorage.removeItem(`${userId}_${key}`);
};